import { useCallback, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getIdFromPathId,
  getShortPath,
} from "../../../../../utils/tabulationUtils";
import { InsertTabuladorV2 } from "../../../../../actions";
import { toast } from "react-toastify";
import { tabulationHandler } from "../../../../../utils/tabulationHandler";

export const useSelectedsTags = (Contact, onClose, InfoUsers) => {
  const tabulatedInfos = useSelector((state) => state.tabulatedInfos);
  const tabulatorOptions = useSelector((state) => state.tabulator);
  const dispatch = useDispatch();
  const [isSaving, setIsSaving] = useState(false);
  const [text, setText] = useState("");

  const initialTags = useMemo(() => {
    if (!Contact) return undefined;
    if (!tabulatedInfos) return undefined;
    return tabulatedInfos[Contact.idatendimento] || undefined;
  }, [Contact, tabulatedInfos]);
  const [selectedsTags, setSelectedTags] = useState([]);
  const isLoading = useMemo(() => {
    if (Boolean(Contact) && Contact.idmidia === "1") return false;
    if (Boolean(Contact) && Contact.idmidia === 1) return false;
    if (Boolean(Contact) && Contact.idmidia === "16") return false;
    if (Boolean(Contact) && Contact.idmidia === 16) return false;
    if (
      Boolean(Contact) &&
      (Contact.idmidia === "3" || Contact.idmidia === 3) &&
      Contact.direction !== "1" &&
      Contact.direction !== 1
    )
      return false;
    // if (Boolean(Contact) && Contact.idmidia === 3) return false;
    // if (Boolean(Contact) && Contact.idmidia === "3") return false;

    if (initialTags === undefined) return true;
    return false;
  }, [initialTags, Contact]);
  const defaultChecked = useMemo(() => {
    if (!Array.isArray(initialTags)) return [];
    return initialTags.map((tag) => tag.id);
  }, [initialTags]);
  const tagsSelectedsTorender = useMemo(() => {
    if (!Array.isArray(selectedsTags)) return [];
    return selectedsTags.map((tag) => ({
      ...tag,
      label: getShortPath(tag.path),
    }));
  }, [selectedsTags]);
  const allTagsToRender = useMemo(() => {
    return Array.isArray(initialTags) && initialTags.length > 0
      ? [...initialTags, ...tagsSelectedsTorender]
      : tagsSelectedsTorender;
  }, [initialTags, tagsSelectedsTorender]);

  const handleSaveTabulations = useCallback(
    async (nodes, textTyped, InfoUsers, initialTags, tagsSelectedsTorender) => {
      if (isSaving || isLoading) return;
      if (!(Array.isArray(nodes) && nodes.length > 0)) return;
      setIsSaving(true);
      const { rejecteds, resolveds } = await InsertTabuladorV2(
        Contact,
        InfoUsers,
        nodes,
        textTyped,
      );
      if (rejecteds.length > 0) {
        toast.error("Houve algum erro ao salvar algumas tabulações", {
          autoClose: 2000,
        });
      } else {
        toast.success("As tabulações foram salvas com sucesso", {
          autoClose: 2000,
        });
      }

      const previewsTags = Array.isArray(initialTags)
        ? [...initialTags, ...tagsSelectedsTorender]
        : [...tagsSelectedsTorender];

      const tagsToUpdate = previewsTags
        .filter(
          (tag) =>
            !rejecteds.some(
              (rejected) =>
                getIdFromPathId(rejected.node.id) === getIdFromPathId(tag.id),
            ),
        )
        .map((tag) => ({ ...tag, id: getIdFromPathId(tag.id) }));

      dispatch(
        tabulationHandler.editTabulatedInfos(
          Contact.idatendimento,
          tagsToUpdate,
        ),
      );

      setSelectedTags([]);

      setIsSaving(false);
      onClose();
    },
    [
      Contact,
      dispatch,
      setIsSaving,
      setSelectedTags,
      onClose,
      isSaving,
      isLoading,
    ],
  );

  const handleChangeTreeSelect = (nodes) => {
    setSelectedTags(nodes);
  };
  const handleChangeText = (e) => {
    const { value } = e.target;
    setText(value);
  };

  const verifyMaxNumberOfSelects = useCallback(
    (currentState, node) => {
      if (!InfoUsers.classificationcount) return true;
      if (
        currentState === "unchecked" &&
        allTagsToRender.length >= InfoUsers.classificationcount
      ) {
        return false;
      }
      return true;
    },
    [allTagsToRender, InfoUsers],
  );

  return {
    tabulatedInfos,
    initialTags,
    isLoading,
    tabulatorOptions,
    defaultChecked,
    selectedsTags,
    tagsSelectedsTorender,
    isSaving,
    text,
    allTagsToRender,
    handleSaveTabulations,
    handleChangeTreeSelect,
    handleChangeText,
    verifyMaxNumberOfSelects,
  };
};
